<ng-container *mobxAutorun>
  <!-- Large screen: inline buttons -->
  <div
    *ngIf="actions && actions.length > 0 && collapseSize !== 'every'"
    class="btn-group {{
      collapseSize === 'none' ? '' : 'd-none d-' + collapseSize + '-block'
    }}"
  >
    <ng-template ngFor let-action [ngForOf]="actions">
      <!-- Anchor action -->
      <a
        lf-button
        *ngIf="action.href"
        [class]="action.class || ''"
        [style]="action.style"
        [size]="buttonsSize"
        [href]="action.href"
      >
        <lf-icon *ngIf="action.icon" [icon]="action.icon"></lf-icon>
        {{ actionText(action) }}
      </a>
      <!-- Regular action (button) -->
      <button
        lf-button
        *ngIf="!action.options && !action.href"
        [class]="action.class || ''"
        [style]="action.style"
        [size]="buttonsSize"
        [isActive]="!!action.isActive && action.isActive()"
        [isDisabled]="
          _isActionRunning(action) ||
          (!!action.isDisabled && action.isDisabled())
        "
        (click)="_runAction(action)"
      >
        <div *ngIf="_isActionRunning(action)" class="action-loading"></div>
        <lf-icon
          *ngIf="!_isActionRunning(action) && action.icon"
          [icon]="action.icon"
        >
        </lf-icon>
        {{ actionText(action) }}
      </button>
      <!-- Action with options (dropdown) -->
      <lf-dropdown *ngIf="action.options">
        <button
          lf-button
          [class]="action.class || ''"
          [style]="action.style"
          [size]="buttonsSize"
          [isDisabled]="!!action.isDisabled && action.isDisabled()"
          [dropdownToggle]="true"
        >
          <div
            *ngIf="_isActionRunning(action) || _isChildOptionRunning(action)"
            class="action-loading"
          ></div>
          <lf-icon
            *ngIf="
              !_isActionRunning(action) &&
              !_isChildOptionRunning(action) &&
              action.icon
            "
            [icon]="action.icon"
          ></lf-icon>
          {{ actionText(action) }}
        </button>
        <lf-dropdown-menu
          [alignRight]="
            action.alignRight == null ? alignMenusRight : action.alignRight
          "
        >
          <ng-container *ngFor="let option of action.options">
            <!-- Anchor option -->
            <a
              lf-dropdown-item
              *ngIf="option.href"
              [class]="option.class || ''"
              [href]="option.href"
            >
              <lf-icon
                *ngIf="option.icon"
                [icon]="option.icon"
                [fixedWidth]="true"
              >
              </lf-icon>
              {{ actionOptionText(action, option) }}
            </a>
            <!-- Regular option (button) -->
            <button
              lf-dropdown-item
              *ngIf="!option.href"
              type="button"
              [class]="option.class || ''"
              [isActive]="!!option.isActive && option.isActive()"
              [isDisabled]="
                _isActionOptionRunning(action, option) ||
                (!!option.isDisabled && option.isDisabled())
              "
              (click)="_runActionOption(action, option)"
            >
              <div
                *ngIf="_isActionOptionRunning(action, option)"
                class="d-inline-block fa-fw"
              >
                <div class="action-loading"></div>
              </div>
              <lf-icon
                *ngIf="!_isActionOptionRunning(action, option) && option.icon"
                [icon]="option.icon"
                [fixedWidth]="true"
              >
              </lf-icon>
              {{ actionOptionText(action, option) }}
            </button>
          </ng-container>
        </lf-dropdown-menu>
      </lf-dropdown>
    </ng-template>
  </div>

  <!-- Small screen: menu buttons -->
  <div
    *ngIf="actions && actions.length > 0 && collapseSize !== 'none'"
    [class]="
      collapseSize === 'every' ? '' : 'd-' + collapseSize + '-none d-block'
    "
  >
    <lf-dropdown>
      <button
        lf-button
        [style]="'outline-secondary'"
        [size]="buttonsSize"
        [dropdownToggle]="true"
      >
        <div *ngIf="_isAnyActionRunning" class="action-loading"></div>
        <lf-icon *ngIf="!_isAnyActionRunning" icon="gear"></lf-icon>
        <!-- Show a label for the actions toggle depending on screen size -->
        <span
          *ngIf="actionsLabelCollapseSize !== 'every'"
          [class]="
            actionsLabelCollapseSize === 'none'
              ? ''
              : 'd-none d-' + actionsLabelCollapseSize + '-inline'
          "
        >
          {{ actionsLabel }}
        </span>
      </button>
      <lf-dropdown-menu [alignRight]="alignMenusRight">
        <ng-container *ngFor="let action of actions; let i = index">
          <!-- Anchor action -->
          <a
            lf-dropdown-item
            *ngIf="action.href"
            [class]="action.class || ''"
            [href]="action.href"
          >
            <lf-icon
              *ngIf="action.icon"
              [icon]="action.icon"
              [fixedWidth]="true"
            >
            </lf-icon>
            {{ actionText(action) }}
          </a>
          <!-- Regular action (button) -->
          <button
            lf-dropdown-item
            type="button"
            *ngIf="!action.options && !action.href"
            [class]="action.class || ''"
            [isActive]="!!action.isActive && action.isActive()"
            [isDisabled]="
              _isActionRunning(action) ||
              (!!action.isDisabled && action.isDisabled())
            "
            (click)="_runAction(action)"
          >
            <div *ngIf="_isActionRunning(action)" class="d-inline-block fa-fw">
              <div class="action-loading"></div>
            </div>
            <lf-icon
              *ngIf="!_isActionRunning(action) && action.icon"
              [icon]="action.icon"
              [fixedWidth]="true"
            >
            </lf-icon>
            {{ actionText(action) }}
          </button>
          <!-- Action with options -->
          <ng-container *ngIf="action.options">
            <!-- Surround actions with options with dividers -->
            <div lf-dropdown-item *ngIf="i > 0" [itemType]="'divider'"></div>
            <h6
              lf-dropdown-item
              [class]="action.class || ''"
              [itemType]="'header'"
            >
              <lf-icon
                *ngIf="action.icon"
                [icon]="action.icon"
                [fixedWidth]="true"
              >
              </lf-icon>
              {{ actionText(action) }}
            </h6>
            <ng-container *ngFor="let option of action.options">
              <!-- Anchor option -->
              <a
                lf-dropdown-item
                *ngIf="option.href"
                [class]="option.class || ''"
                [href]="option.href"
              >
                {{ actionOptionText(action, option) }}
              </a>
              <!-- Regular option (button) -->
              <button
                lf-dropdown-item
                type="button"
                *ngIf="!option.href"
                [class]="option.class || ''"
                [isActive]="!!option.isActive && option.isActive()"
                [isDisabled]="
                  _isActionOptionRunning(action, option) ||
                  (!!option.isDisabled && option.isDisabled())
                "
                (click)="_runActionOption(action, option)"
              >
                <div
                  *ngIf="_isActionOptionRunning(action, option)"
                  class="d-inline-block fa-fw"
                >
                  <div class="action-loading"></div>
                </div>
                {{ actionOptionText(action, option) }}
              </button>
            </ng-container>
            <div
              lf-dropdown-item
              *ngIf="i < actions.length - 1 && !actions[i + 1].options"
              [itemType]="'divider'"
            ></div>
          </ng-container>
        </ng-container>
      </lf-dropdown-menu>
    </lf-dropdown>
  </div>
</ng-container>
